/**
 * @copyright 2026 @ DigiNet
 * @author ANHTAI
 * @create 2026/08/10 09:15
 * @update 2026/08/10 09:15
 */

import Api from "../../../services/api";

export function loadPermissionPayment(params, cb) {
    return async () => {
        await Api.put('/w14f1020/load-permission-payment', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadComboGeneral(params, cb) {
    return async () => {
        await Api.put('/w14f1020/load-combo', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function loadGrid(params, cb) {
    return async () => {
        await Api.put('/w14f1020/load-form', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function deleteRow(params, cb) {
    return async () => {
        await Api.delete('/w14f1020/delete', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}

export function updateStatus(params, cb) {
    return async () => {
        await Api.put('/w14f1020/update-status', params)
            .then(result => {
                if (cb) {
                    if (result && result.code && result.code !== 200) cb(result, null);
                    else cb(null, result.data);
                }
            });
    };
}